import template from './reset.html';
import { STATES } from '../../../constants';
import { actions, selectors } from '../../../state';
import './reset.global.css';

class ResetController {
  constructor(updStore, appShell) {
    'ngInject';
    Object.assign(this, { updStore, appShell });
  }

  $onInit() {
    this.disconnect = this.updStore.connect(mapStateToThis)(this);
  }

  $onDestroy() {
    this.disconnect();
  }

  submit({ password }) {
    const { dispatch } = this.updStore;

    const data = {
      security_token: this.resetToken,
      password,
    };

    const success = () => {
      // dispatch(actions.router.stateGo(STATES.SIGN_IN));
      this.appShell.interactors.session.actions.setResetPassword(true);
      this.appShell.interactors.router.go('/sign-in');
      // dispatch(
      //   actions.message.success(
      //     `Way to go! We've set your password - now you can sign in below!`
      //   )
      // );
    };

    const error = () => {
      dispatch(
        actions.message.error(
          this.errorMessage ||
            'Sorry. There was an error resetting your password.'
        )
      );
    };

    dispatch(actions.user.singleton().update(data)).then(success, error);
  }
}

export const ResetComponent = {
  template,
  controller: ResetController,
};

function mapStateToThis(state) {
  return {
    resetToken: selectors.router.currentParamsProp('resetToken', state),
    submitting: selectors.pending.match(actions.user.isUpdate, state),
    errorMessage: selectors.error.message(actions.user.isUpdate, state),
  };
}
